import { stay } from '../sendData';
import { useDeviceStore } from '@/stores';

export interface StayData {
  id: string; // 资讯ID
  obj_type: 'stay' | 'video_over'; // stay：图文停留类型，video_over：视频、音频停留类型
  type: 1 | 2 | 3; // 1图文，2视频，3音频
  spm: string;
  scm: string;
  request_id: string;
  network: string;
  device_id: string;
  stay_time: number;
}

export type CustomData = Omit<StayData, 'stay_time' | 'network' | 'device_id'> &
  Partial<Pick<StayData, 'network' | 'device_id'>>;

const SEND_TIME = 3; // 发送时间3秒
const MAX_STAY_TIME = 5 * 24 * 60 * 60; // 最大停留时间5天

export default class PageLeave {
  constructor(sendTime = SEND_TIME, maxStayTime = MAX_STAY_TIME) {
    this.sendTime = sendTime;
    this.maxStayTime = maxStayTime;
  }

  private sendTime = 0; // 发送时间，单位s
  private maxStayTime = 0; // 最大停留时间，单位s
  startTime = 0; // 开始时间，时间戳
  endTime = 0; // 开始时间，时间戳
  url = ''; // 当前页面url
  title = ''; // 当前页面title
  customData: CustomData | null = null;

  reset() {
    this.startTime = 0;
    this.endTime = 0;
  }

  /**
   * 记录当前页面的开始时间，url，title
   * @param data - 自定义数据
   *
   */
  start(data?: CustomData) {
    this.startTime = Date.now();
    this.endTime = this.startTime;
    this.url = window.location.href;
    this.title = document.title;
    if (data) {
      const deviceStore = useDeviceStore();
      this.customData = {
        ...data,
        network: data.network || deviceStore.network,
        device_id: data.device_id || deviceStore.deviceId,
      };
    }
  }

  /**
   * 发送停留时间数据
   * 1. 获取当前页面的停留时间数据
   * 2. 如果停留时间小于 {@link PageLeave.sendTime}，则不发送数据
   * 3. 使用 {@link useDeviceStore} 读取当前设备的 network 和 deviceId
   * 4. 发送数据，成功打印日志，失败打印错误
   */
  async end() {
    if (!this.customData?.id) {
      console.error('id is required');
      return;
    }
    const data = this.getData();
    if (data.stayTime < this.sendTime) {
      return;
    }
    try {
      const res = await stay({
        ...this.customData,
        stay_time: data.stayTime,
      });
      console.log(res);
    } catch (error) {
      console.error(error);
    }
  }

  /**
   * @description
   * 获取当前页面的停留时间数据
   * @returns {Object} 数据对象，包含停留时间、当前页面url、当前页面title
   * @property {number} stayTime - 停留时间，单位s
   * @property {string} url - 当前页面url
   * @property {string} title - 当前页面title
   */
  getData() {
    this.endTime = Date.now();
    let stayTime = (this.endTime - this.startTime) / 1000;
    if (isNaN(stayTime) || stayTime < 0 || stayTime > this.maxStayTime) {
      stayTime = 0;
    }
    stayTime = Math.round(stayTime);
    const data = {
      stayTime: stayTime,
      url: this.url,
      title: this.title,
    };
    return data;
  }
}
